module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "search-text"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    staticClass: "form-control",
    class: {
      notValid: _vm.searchInput.length < _vm.minCharsToFilterText
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('searchBox.searchPlaceholder')
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                                     "), (_vm.searchInput.length >= _vm.minCharsToFilterText) ? _c('span', [_vm._v(_vm._s(_vm.$t('searchBox.showing')) + " " + _vm._s(_vm.pageElements.numElements) + " " + _vm._s(_vm.$t('searchBox.showingResults')))]) : _vm._e()])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clear-fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-sort col-sm-6"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.pageElements.currentSortConcept === 'rank'
    }
  }, [_c('button', {
    staticClass: "seamless-button",
    on: {
      "click": function($event) {
        _vm.sortBy('rank')
      }
    }
  }, [(_vm.pageElements.currentOrder === 'desc' && _vm.pageElements.currentSortConcept === 'rank') ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]) : _vm._e(), _vm._v(" "), (_vm.pageElements.currentOrder === 'asc' && _vm.pageElements.currentSortConcept === 'rank') ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_up")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('searchBox.rank')))])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.pageElements.currentSortConcept === 'nomAplicacio'
    }
  }, [_c('button', {
    staticClass: "seamless-button",
    on: {
      "click": function($event) {
        _vm.sortBy('nomAplicacio')
      }
    }
  }, [(_vm.pageElements.currentOrder === 'desc' && _vm.pageElements.currentSortConcept === 'nomAplicacio') ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]) : _vm._e(), _vm._v(" "), (_vm.pageElements.currentOrder === 'asc' && _vm.pageElements.currentSortConcept === 'nomAplicacio') ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_up")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('searchBox.relevance')))])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.pageElements.currentSortConcept === 'dataPublicacio'
    }
  }, [_c('button', {
    staticClass: "seamless-button",
    on: {
      "click": function($event) {
        _vm.sortBy('dataPublicacio')
      }
    }
  }, [(_vm.pageElements.currentOrder === 'desc' && _vm.pageElements.currentSortConcept === 'dataPublicacio') ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_down")]) : _vm._e(), _vm._v(" "), (_vm.pageElements.currentOrder === 'asc' && _vm.pageElements.currentSortConcept === 'dataPublicacio') ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("arrow_drop_up")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('searchBox.date')))])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "extra-bottom-padding background-extralight extra-bottom-padding",
    attrs: {
      "id": "items"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.pageElements.elements.length === 0 && !_vm.isLoading) ? _c('div', {
    staticClass: "no-results"
  }, [_c('p', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("map")]), _vm._v(" " + _vm._s(_vm.$t('searchBox.noResults')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('thumbnailmapList', {
    attrs: {
      "maxLengthTitle": 40,
      "maxLengthDesc": 50,
      "homePreviewMaps": _vm.galleryItems,
      "selectedLang": _vm.selectedLang,
      "isMobile": false
    },
    on: {
      "clonarMapa": function($event) {
        _vm.clonarMapa($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.pageElements.numPages > 1) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('paginate', {
    attrs: {
      "force-page": _vm.pageElements.currentPage - 1,
      "page-count": _vm.pageElements.numPages,
      "page-range": 3,
      "margin-pages": 2,
      "click-handler": _vm.clickCallback,
      "prev-text": '<',
      "next-text": '>',
      "container-class": 'pagination pagination-lg',
      "page-class": 'page-item'
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-sort-toggle"
  }, [_c('button', {
    staticClass: "seamless-button icon-only"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b34af10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gallery/components/gallery-list/gallery-list.vue
// module id = 304
// module chunks = 0